class RichTextFactory {
    constructor($compile, DoclrModalService, $rootScope) {
        'ngInject';
        this.initStarted = false;
        this.$compile = $compile;
        this.DoclrModalService = DoclrModalService;
        this.$rootScope = $rootScope;
    }


    setLoadScriptsCallback(callbackFn){
        this.loadScriptsCallbackFn = callbackFn;
    }

    createEditor(editorContainer, toolbarId, $scope,config){
        this._loadEditor(editorContainer, toolbarId,$scope, config);
    }

    getValueFrom(editor){
        let rawHtml = editor.getSemanticHTML();
        if(rawHtml){
            rawHtml = rawHtml.trim();
        }

        if(!rawHtml || rawHtml === '<p></p>'){
            return undefined;
        }

        return {
            rawHtml : rawHtml,
            editorContent: editor.getContents()
        }
    }

    _loadEditor(editorContainer, toolbarId,$scope, config){

        if(!this.initStarted){
            this._initQuill();
        }

        if(window.DoclrQuill){
            this._createEditor(editorContainer, toolbarId,$scope, config);
        }
        else{
            window.setTimeout(()=> this._loadEditor(editorContainer, toolbarId,config), 10);
        }
    }

    _initQuill(){
        this.initStarted = true;

        // this.loadScriptsCallbackFn();
    }

    _createEditor(editorContainer, toolbarId, $scope, config) {
        const quill = new window.DoclrQuill(editorContainer, {
            theme: 'snow',
            modules:{
                toolbar: {
                    container:  '#'+toolbarId,
                    handlers: {
                    'color': (value) => this.showColorPicker(value, quill, 'color'),
                    'background': (value) => this.showColorPicker(value, quill, 'background'),
                    'ipdcProduct':() => this.pickIpdcProduct(quill, config.defaultProductId)
                    }
                }
            }
        });

        document.querySelectorAll('#'+ toolbarId + ' .ql-picker').forEach(x=> {
            this.$compile(x)($scope);
        });

        this.createColorPicker(quill,'color', editorContainer);
        this.createColorPicker(quill, 'background', editorContainer);

        if(config){
            if(config.onUpdate){
                quill.on('text-change', (delta, oldDelta, source) => {

                    const isInsertPlacholder = delta && delta.ops && delta.ops.filter(x=> x.insert && x.insert[0] === "{" && x.insert[x.insert.length-1] === "}").length > 0;

                    if (source === 'user' || isInsertPlacholder) {
                        const newValue = this.getValueFrom(quill);
                        config.onUpdate(newValue);
                    }
                });
            }
            if(config.onCreate){
                config.onCreate(quill);
            }
        }
    }

    createColorPicker(quill, attributeName, quillContainer){
        const pickerId = 'color-picker-'+ attributeName;
        let picker = document.getElementById(pickerId);
        if(picker){
            picker.parentNode.removeChild(picker);
        }
        picker = document.createElement('input');
        picker.id = pickerId;
        picker.type = 'color';
        picker.value = '#428bca';
        picker.classList.add('ql-color-picker-input');
        quillContainer.appendChild(picker);

        picker.addEventListener('input', () => {
            quill.format(attributeName, picker.value);
        }, false);

    }

    showColorPicker(value, quill, attributeName) {
        const pickerName = 'color-picker-'+ attributeName;
        if (value === 'color-picker') {
            let picker = document.getElementById(pickerName);
            picker.click();
        } else {
            quill.format(attributeName, value);
        }
    }

    setIpdcProducts(ipdcProducts){
        this.ipdcProducts = ipdcProducts;
    }

    pickIpdcProduct(quill, defaultProductId){
        let model = {
            selectedPlaceholder: undefined,
            defaultProductId: defaultProductId
        }

        var scope = this.$rootScope.$new(true);
        this.DoclrModalService.openEditModal(
            '/partials/components/utils/doclr.rich.text.ipdc.picker.html',
            {
                backdrop:'static',
                modalSize: 'lg',
                placeholderService: new IpdcProductPlacholderPickerService(model, this.ipdcProducts, scope),
                model: model,
                scope: scope
            }).then(()=> {
            const selection = quill.getSelection(true);
            quill.insertText(selection.index, model.selectedPlaceholder);
        } )
    }
}

class RichTextScriptLoaderController {
    constructor($scope, RichTextFactory) {
        'ngInject';

        $scope.RichTextVisibility = {isVisible:false};
        RichTextFactory.setLoadScriptsCallback( () => $scope.RichTextVisibility.isVisible = true );
    }

}

class DoclrRichTextFormDirective {
    constructor() {
        'ngInject';
        this.restrict = 'E';
        this.templateUrl = '/partials/components/utils/doclr.rich.text.editor.form.html';
        this.require = 'ngModel';
        this.scope = {
            defaultProductId: '<'
        }
    }

    controller($scope, $state) {
        $scope.state = $state;
    }

    link(scope, element, attrs, ngModelCtrl) {
        scope.onChange = function (newValue){
            ngModelCtrl.$setViewValue(newValue);
        }

        ngModelCtrl.$render = function () {
            scope.initialValue =  ngModelCtrl.$viewValue;
            scope.model = ngModelCtrl.$viewValue;
        };
    }
}

class RichTextController {
    constructor($scope, RichTextFactory) {
        this.RichTextFactory = RichTextFactory;
        this.$scope = $scope;


        if(!window.NextRichTextEditorId){
            window.NextRichTextEditorId = 1;
        }
        this.richTextEditorId =  'RichTextEditorId' + window.NextRichTextEditorId;
        this.richTextEditorToolbarId =  'richTextEditorToolbarId' + window.NextRichTextEditorId;

        window.NextRichTextEditorId++;
    }

    $onInit() {
        this._loadEditor( );
    }

    _loadEditor(){

        let editorContainer = document.getElementById(this.richTextEditorId);

        if(editorContainer){
            this.RichTextFactory.createEditor(editorContainer, this.richTextEditorToolbarId , this.$scope, {
                onUpdate: (text) => this._onUpdate(text),
                onCreate: (editor) => this._onCreate(editor),
                defaultProductId: this.defaultProductId
            });
        }
        else {
            window.setTimeout(() => this._loadEditor(), 10);
        }
    }

    _onUpdate(newValue) {
        if (this.onChange) {
            this.onChange({newValue:newValue});
        }
    }

    addPlaceHolder(){
        alert("gg");
    }

    _onCreate(editor) {
        if (this.initialValue){
            //Backwards compatibility
            if(this.initialValue.rawHtml && !this.initialValue.editorContent ){
                editor.clipboard.dangerouslyPasteHTML(this.initialValue.rawHtml);
                window.setTimeout(()=> this._onUpdate(this.RichTextFactory.getValueFrom(editor)) , 50);
            }else{
                if(this.initialValue.editorContent){
                    editor.setContents(this.initialValue.editorContent);
                }
            }
        }
    }
}

class IpdcProductPlacholderPickerService {
    constructor(model, ipdcProducts, scope){
        this.ipdcProducts = ipdcProducts;
        this.model = model;
        this.selectedProductId = model.defaultProductId;
        this.selectedProduct = undefined;
        this.selectedType = undefined;
        this.selectedTypeSelector = undefined;
        this.selectedLanguage = undefined;
        this.availableTypes = [];
        this.availableLanguages = undefined;
        this.availableOrders = undefined;
        this.selectedOrderId = undefined;
        this.availableProducts = ipdcProducts.map(p => {
            return {
                id: p.id,
                name: this.getName(p.product.naam)
            }
        })
        this.$scope = scope;
        this.availableOrdersTypes=undefined;
        this.selectedOrderTypeSelector=undefined;

        this.result = undefined;

        let that = this;


        this.types = [
            {
                label: 'Naam',
                selector:'naam'
            },
            {
                label: 'Beschrijving',
                selector:'beschrijving'
            },
            {
                label: 'Voorwaarden',
                selector:'voorwaarden',
                orders:[
                    {
                        label: 'Naam',
                        selector: 'naam'
                    },
                    {
                        label: 'Beschrijving',
                        selector: 'beschrijving'
                    }
                ]
            },
            {
                label: 'Procedures',
                selector:'procedures',
                orders:[
                    {
                        label: 'Naam',
                        selector: 'naam'
                    },
                    {
                        label: 'Beschrijving',
                        selector: 'beschrijving'
                    }
                ]
            },
            {
                label: 'Kosten',
                selector:'kosten',
                orders:[
                    {
                        label: 'Naam',
                        selector: 'naam'
                    },
                    {
                        label: 'Beschrijving',
                        selector: 'beschrijving'
                    }
                ]
            }
        ];

        if(model.defaultProductId){
            this.updateSelectedProduct();
        }
    }

    updateSelectedProduct(){
        this.selectedProduct = this.ipdcProducts.filter(x=>x.id === this.selectedProductId)[0];
        this.selectedTypeSelector = undefined;
        this.selectedType = undefined;
        this.availableLanguages = undefined;
        this.selectedLanguage = undefined;
        this.result = undefined;
        this.availableOrders = undefined;
        this.selectedOrderId = undefined;
        this.availableOrdersTypes=undefined;
        this.selectedOrderTypeSelector=undefined;

        this.updateAvailableTypes();
    }

    updateSelectedOrder(){
        this.availableOrdersTypes=undefined;
        this.selectedOrderTypeSelector=undefined;
        this.availableLanguages = undefined;
        this.selectedLanguage = undefined;
        this.availableOrdersTypes =  this.selectedType.orders;
        this.result = undefined;
        let beschrijvingOrderTypes = this.availableOrdersTypes.filter(x=>x.selector === 'beschrijving');
        if(beschrijvingOrderTypes.length > 0){
            this.selectedOrderTypeSelector = beschrijvingOrderTypes[0].selector;
            this.updateSelectedOrderType();
        }
    }

    updateSelectedType(){
        this.selectedType = this.types.filter(x=> x.selector === this.selectedTypeSelector)[0];
        this.availableLanguages = undefined;
        this.selectedLanguage = undefined;
        this.availableOrders = undefined;
        this.selectedOrderId = undefined;
        this.result = undefined;
        this.availableOrdersTypes=undefined;
        this.selectedOrderTypeSelector=undefined;

        if(this.selectedType.orders){
            this.availableOrders = this.selectedProduct.product[this.selectedTypeSelector].map(x=>{
                return{
                    'id': x.order,
                    'name': x.order+ ': ' + this.getName( x['naam'])
                }
            });

            if(this.availableOrders.length === 1){
                    this.selectedOrderId = this.availableOrders[0].id;
                    this.updateSelectedOrder();
            }

        }else{
            this.availableLanguages =  Object.keys(this.selectedProduct.product[this.selectedTypeSelector]);
            this.setNlAsDefaultSelection();
        }
    }

    setNlAsDefaultSelection(){
        let nlLanguages = this.availableLanguages.filter(x=>x === 'nl');
        if(nlLanguages.length > 0){
                this.selectedLanguage = nlLanguages[0];
                this.updateSelectedLanguage();
        }
    }

    updateSelectedLanguage(){
        this.result = undefined;
        if(!this.selectedType.orders){
            this.result = this.selectedProduct.product[this.selectedTypeSelector][this.selectedLanguage];
        }else{
            this.result=  this.selectedProduct.product[this.selectedTypeSelector]
                .filter(x=> x.order === this.selectedOrderId)[0][this.selectedOrderTypeSelector][this.selectedLanguage];
        }
    }

    updateAvailableTypes(){
        if(!this.selectedProduct){
            this.availableTypes = [];
            return;
        }

        this.availableTypes =  this.types.filter(type =>{
            return this.selectedProduct.product[type.selector];
        })
    }

    updateSelectedOrderType(){
        this.availableLanguages = undefined;
        this.selectedLanguage = undefined;
        this.result = undefined;

        this.availableLanguages =  Object.keys(this.selectedProduct.product[this.selectedTypeSelector]
            .filter(x=> x.order === this.selectedOrderId)[0][this.selectedOrderTypeSelector]);

        this.setNlAsDefaultSelection();
    }

    selectPlaceholder(closeFunction){

        let parts =  [this.selectedProduct.id, this.selectedTypeSelector ];

        if(this.selectedType.orders){
            parts.push(this.selectedOrderId);
            parts.push(this.selectedOrderTypeSelector)
        }

        parts.push(this.selectedLanguage);

        const partsString = parts.join(":");

        this.model.selectedPlaceholder = "{"+partsString+"}";
        closeFunction();
    }

    getName(item){
        if (item && item.nl) {
            return item && item.nl;
        }
        return "niet gekend";
    }
}



(function () {
    'use strict';

    angular.module('doclr.components.util')
        .service('RichTextFactory', RichTextFactory)
        .controller("RichTextScriptLoaderController", RichTextScriptLoaderController)
        .component('doclrRichTextComponent', {
            templateUrl: '/partials/components/utils/doclr.rich.text.editor.html',
            controller: ($scope, RichTextFactory) => new RichTextController($scope, RichTextFactory),
            controllerAs: 'richTextCtrl',
            bindings: {
                onChange: '&',
                initialValue : '<',
                defaultProductId: '<'
            }
        })
        .directive('doclrRichTextFormComponent', () => new DoclrRichTextFormDirective());



})();